var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "#14181F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05816 5.56442C4.08048 6.61818 3.37055 7.86872 2.95718 9.20851L4.79366 10.2688C6.127 11.0386 6.127 12.9631 4.79366 13.7329L2.95538 14.7942C3.16066 15.4568 3.44244 16.1069 3.80386 16.7329C4.16528 17.3589 4.5874 17.928 5.05851 18.437L6.89683 17.3756C8.23016 16.6058 9.89683 17.5681 9.89683 19.1077V21.2283C11.2638 21.5402 12.7018 21.5507 14.1032 21.2309L14.1032 19.1078C14.1032 17.5682 15.7699 16.6059 17.1032 17.3757L18.9419 18.4373C19.9196 17.3835 20.6295 16.133 21.0429 14.7932L19.2063 13.7329C17.873 12.9631 17.873 11.0386 19.2063 10.2687L21.0446 9.20739C20.8394 8.54489 20.5576 7.89477 20.1962 7.26879C19.8348 6.64278 19.4126 6.07369 18.9415 5.56465L17.1032 6.62599C15.7699 7.39579 14.1032 6.43354 14.1032 4.89394V2.77334C12.7362 2.46144 11.2983 2.45099 9.89683 2.77081L9.89683 4.89392C9.89683 6.43352 8.23016 7.39577 6.89683 6.62597L5.05816 5.56442Z",
    stroke: "#14181F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.10679de56b08a95308a21a67bae17999.svg";
export { ForwardRef as ReactComponent };